import { c as _c } from "react/compiler-runtime";
import CustomButton from './components/custom-button';
import GrantEditRightsDialog from './components/grant-edit-rights-dialog';
import useAssumeBanner from './hooks/use-assume-banner';
type AssumeBannerProps = {
  hideActions?: boolean;
};
const AssumeBanner = t0 => {
  const $ = _c(34);
  const {
    hideActions
  } = t0;
  const {
    t,
    showEditRightsForm,
    canRequestAdditionalPermissions,
    canSwitchToRole,
    currentPermissions,
    isAssumedSession,
    isAssumedSessionEditMode,
    isAccessRequestsPending,
    isSwitchingToRole,
    org,
    roleName,
    handleChangeEdit,
    handleCloseEditRightsForm,
    handleRequestAdditionalPermissions,
    handleSwitchToRole,
    handleLogout,
    getEditButtonText
  } = useAssumeBanner();
  if (!isAssumedSession) {
    return null;
  }
  const t1 = `w-full sticky top-0 z-50 ${isAssumedSessionEditMode ? "bg-error text-error" : "bg-primary text-primary"} text-body-2 max-w-full rounded-t flex items-center justify-center`;
  let t2;
  if ($[0] !== isAssumedSessionEditMode || $[1] !== org?.name || $[2] !== t) {
    t2 = isAssumedSessionEditMode ? t(_temp, {
      orgName: org?.name
    }) : t(_temp2, {
      orgName: org?.name
    });
    $[0] = isAssumedSessionEditMode;
    $[1] = org?.name;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = hideActions ? "." : "";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="flex items-center gap-1">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== canRequestAdditionalPermissions || $[8] !== canSwitchToRole || $[9] !== getEditButtonText || $[10] !== handleChangeEdit || $[11] !== handleLogout || $[12] !== handleRequestAdditionalPermissions || $[13] !== handleSwitchToRole || $[14] !== hideActions || $[15] !== isAccessRequestsPending || $[16] !== isAssumedSessionEditMode || $[17] !== isSwitchingToRole || $[18] !== roleName || $[19] !== t) {
    t5 = !hideActions && <><span className="mx-2">·</span>{canSwitchToRole && <><CustomButton onClick={handleSwitchToRole} disabled={isSwitchingToRole} isAssumedSessionEditMode={isAssumedSessionEditMode}>{roleName ? t(_temp3, {
            roleName
          }) : t(_temp4)}</CustomButton><span className="mx-2">·</span></>}{!isAccessRequestsPending && <><CustomButton onClick={handleChangeEdit} disabled={isAccessRequestsPending} isAssumedSessionEditMode={isAssumedSessionEditMode}>{getEditButtonText()}</CustomButton>{canRequestAdditionalPermissions && <><span className="mx-2">·</span><CustomButton onClick={handleRequestAdditionalPermissions} disabled={isAccessRequestsPending} isAssumedSessionEditMode={isAssumedSessionEditMode}>{t(_temp5)}</CustomButton></>}<span className="mx-2">·</span></>}<CustomButton onClick={handleLogout} disabled={isAccessRequestsPending} isAssumedSessionEditMode={isAssumedSessionEditMode}>{t(_temp6)}</CustomButton></>;
    $[7] = canRequestAdditionalPermissions;
    $[8] = canSwitchToRole;
    $[9] = getEditButtonText;
    $[10] = handleChangeEdit;
    $[11] = handleLogout;
    $[12] = handleRequestAdditionalPermissions;
    $[13] = handleSwitchToRole;
    $[14] = hideActions;
    $[15] = isAccessRequestsPending;
    $[16] = isAssumedSessionEditMode;
    $[17] = isSwitchingToRole;
    $[18] = roleName;
    $[19] = t;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t4 || $[22] !== t5) {
    t6 = <div className="flex items-baseline pt-2 pb-2.5">{t4}{t5}</div>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t1 || $[25] !== t6) {
    t7 = <div className={t1} role="alert">{t6}</div>;
    $[24] = t1;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== currentPermissions || $[28] !== handleCloseEditRightsForm || $[29] !== showEditRightsForm) {
    t8 = <GrantEditRightsDialog open={showEditRightsForm} onClose={handleCloseEditRightsForm} initialScopes={currentPermissions} />;
    $[27] = currentPermissions;
    $[28] = handleCloseEditRightsForm;
    $[29] = showEditRightsForm;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== t7 || $[32] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
};
export default AssumeBanner;
function _temp($) {
  return $.editModeTitle;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.logInAsRole;
}
function _temp4($_2) {
  return $_2.switchToRole;
}
function _temp5($_3) {
  return $_3.requestAdditional;
}
function _temp6($_4) {
  return $_4.logOut;
}